@if (dialogform) {
  <div>
    <div class="fixed-top" #headerDiv>
      @for (alert of alerts; track alert; let aIndex = $index) {
        <div class="alert alert-danger" role="alert">
          {{alert.text}}
          <button type="button" class="close" (click)="dismissAlert(aIndex)" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      }
      <div class="row">
        <div class="col" style="padding-top: .5rem;padding-left: 25px;">
          @if (hideOnReset) {
            <span #ContentElementheader class="dformTextColor"></span>
          }
        </div>
        <div class="col" style="text-align: right; margin: .5rem 15px 0.2rem;">
          @if (transactionId) {
            <span class="dformTextColor">
              Reference: {{transactionId}}
            </span>
          }
        </div>
      </div>
      @if (hideOnReset) {
        <div #ContentElement class="card-row row">
          @for (serviceLine of serviceLines; track serviceLine) {
            <div class="card-container">
              @if (selectedServiceLine) {
                <div class="card">
                  @if (serviceLine.label === selectedServiceLine.label) {
                    <div class="card-body active">
                      <img style="width:3rem;height:2.5rem;" class="card-img-top" alt="{{serviceLine.label}}"
                        src="assets/icons/{{selectedServiceLine.label.charAt(0).toUpperCase() + selectedServiceLine.label.slice(1)}}.svg">
                        <label class="card-text active dformLabelColor">{{formatServiceLineText(serviceLine.label)}}</label>
                      </div>
                    }
                    @if (serviceLine.label != selectedServiceLine.label) {
                      <div class="card-body">
                        <img style="width:3rem;height:2.5rem;" class="card-img-top" alt="{{serviceLine.label}}"
                          src="assets/icons/{{serviceLine.label.charAt(0).toUpperCase() + serviceLine.label.slice(1)}}.svg">
                          <label class="card-text dformLabelColor">{{formatServiceLineText(serviceLine.label)}}</label>
                        </div>
                      }
                    </div>
                  }
                  @if (!selectedServiceLine) {
                    <div class="card inactive card-img-top dformLabelColor" tabindex="0"
                      (focus)="cardFocus(serviceLine)" (focusout)="cardFocusOut()" (keydown)="cardKeydown($event)" role="button">
                      <div class="card-body" style="cursor: pointer;" (click)="activateServiceLine(serviceLine)"
                        (mouseover)="serviceLine.imgsrc = serviceLine.onhov" (mouseout)="serviceLine.imgsrc = serviceLine.nohov">
                        <img style="width:3rem;height:2.5rem;" alt="{{serviceLine.label}}" [src]="serviceLine.imgsrc"
                          aria-hidden="true" />
                          <label class="card-text" style="cursor: pointer;">{{formatServiceLineText(serviceLine.label) }}</label>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }

      <!-- appBotScrollBottom -->
      <main>
        <div id="main-container" class="container-fluid" appBotScrollBottom
          [style.top.px]="headerDivEl ? headerDivEl.nativeElement.offsetHeight : 225">
          @for (formElement of formElements; track formElement; let index = $index) {
            <div class="row dFormBorder">
              <div class="col">
                @for (label of formElement.labels; track label) {
                  <div class="row">
                    <div class="col" style="padding-top: 1.5rem;">
                      <p class="dformTextColor" [innerHTML]="label.text"></p>
                    </div>
                  </div>
                }
              </div>
              <div
                [ngClass]="formElement.controls[0].type == 'list' && formElement.controls[0].list.length > 30 ? 'col-9' : 'col'"
                style="max-width:none;padding:16px">
                @for (control of formElement.controls; track control) {
                  <div class="row"
                    [ngStyle]="control.list && control.list.length > 30 ? '' : {'float':'right' }">
                    <!-- Input control -->
                    @if (control.type == 'input') {
                      <div class="col">
                        <!-- <div *ngIf="control.hideCreateCaseFrom; else attachmentsForm" class="input-group"> -->
                        <div class="input-group" style="flex-wrap: inherit;">
                          <input type="text" [(ngModel)]="control.value" [tabindex]="control.selected ? -1 : 0"
                            [ngClass]="control.selected || formElements[formElements.length - 1].showAttachments ? 'inp-max-width':'inp-min-width'"
                            class="form-control dda-color-contrast-input shadow-none" style="border-radius: 0.25rem;min-width:224px"
                            [disabled]="control.selected" placeholder="Enter your text"
                            (keydown.enter)="control.selected = true;sendControlSelection(control)" appAutoFocus />
                            @if (!control.selected) {
                              <div>
                                @if (!formElements[formElements.length - 1].showAttachments) {
                                  <span class="input-group-btn"
                                    style="padding-left: 12px;">
                                    <button role="button" style="padding-left:10px;padding-top:3px;height:40px;width:40px;" tabindex="0"
                                      class="btn btn-primary border-0" [disabled]="control.selected || !control.value" type="button"
                                      (click)="control.selected = true; sendControlSelection(control)" title="Submit"
                                      (mouseover)="!control.selected && control.value && myImgSrcPaperPlane = 'assets/paper-plane-solid.svg'"
                                      (mouseout)="myImgSrcPaperPlane = 'assets/paperplane.png'">
                                      <img [src]="myImgSrcPaperPlane" alt="Esme Icon" style="width:1.2rem" />
                                    </button>
                                  </span>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <!-- buttons control -->
                      @if (control.type == 'buttons') {
                        <div class="col" style="padding:0;margin: 0;">
                          <div class="btn-group btn-group-toggle" role="group" aria-label="toggle"
                            style="float:right;flex-wrap: wrap;row-gap: 16px;justify-content: flex-end;">
                            @for (button of control.buttons; track button) {
                              <label class="btn" role="button"
                                (keydown)="index != formElements.length - 1 ? {} : selectWithEnterKey($event, control, button)"
                                [ngClass]="[button.selected ? 'btn-primary-dforms' : 'btn-outline-primary-dforms', index != formElements.length - 1 ? 'disabled' : '']" ngbButtonLabel
                                [tabindex]="index != formElements.length - 1 ? -1 : 1"
                                style="margin-right: 8px; text-align: center; border-radius: 4px;">
                                <input type="checkbox" ngbButton [(ngModel)]="button.selected"
                                  [disabled]="index != formElements.length - 1" (click)="sendControlSelection(button)">
                                  {{ button.label }}
                                </label>
                              }
                            </div>
                          </div>
                        }
                        <!-- dropdown listbox -->
                        @if (control.type == 'ddList') {
                          <div ngbDropdown container="body" class="col d-inline-block">
                            <div style="float:right;">
                              <!-- Dropdown Button -->
                              <button
                                class="btn btn-primary"
                                id="ddlist"
                                [disabled]="control.selected"
                                ngbDropdownToggle
                                style="width:280px;text-align-last: justify;"
                                tabindex="1"
                                role="combobox"
                                aria-haspopup="listbox"
                                [attr.aria-expanded]="isDropdownOpen ? 'true' : 'false'"
                                [attr.aria-activedescendant]="activeItemId"
                                (click)="toggleDropdown()"
                                (keydown)="onKeyDown($event)">
                                <div style="display: inline-table;">{{ getListInitialText(control.ddList) }}</div>
                              </button>
                              <!-- Dropdown Menu -->
                              <div
                                ngbDropdownMenu
                                role="listbox"
                                aria-labelledby="ddlist"
                                [attr.aria-hidden]="!isDropdownOpen"
                                aria-live="assertive">
                                <!-- Dropdown Items -->
                                @for (listItem of control.ddList; track listItem; let i = $index) {
                                  <button
                                    ngbDropdownItem
                                    tabindex="2"
                                    role="option"
                                    [id]="'listItem-' + i"
                                    [attr.aria-selected]="listItem.selected ? 'true' : 'false'"
                                    (click)="control.selected = true;selectItem(listItem, i)">
                                    {{ listItem.label }}
                                  </button>
                                }
                              </div>
                            </div>
                          </div>
                        }
                        <!-- search results list -->
                        @if (control.type == 'list') {
                          <div ngbDropdown class="col d-inline-block" style="width: 312px;">
                            @if (control.list.length > pageSize && index == formElements.length - 1) {
                              <div class="form-group ">
                                <input type="text" class="form-control" id="search-text" aria-describedby="search-text"
                                  [(ngModel)]="searchText" placeholder="Enter text to filter results" [disabled]="control.selected"
                                  autofocus>
                                </div>
                              }
                              <ul class="list-group">
                                @for (listItem of control.list | appFilter: searchText | slice: (currentPage - 1) * pageSize : ((currentPage - 1) * pageSize) + pageSize; track listItem) {
                                  <a href="#" class="list-group-item list-group-item-action page-link" style="margin-top: 2px;"
                                    [tabindex]="control.selected ? -1 : 0"
                                    [ngClass]="control.selected ? 'disabled' : ''"
                                    [ngStyle]="control.selected ? { 'cursor' :' default' }:''"
                                    (click)="$event.preventDefault(); control.selected ? false : sendControlSelection(listItem);control.selected = true;">
                                    {{listItem.label}}
                                  </a>
                                }
                              </ul>
                              @if (control.list.length > pageSize && !control.selected) {
                                <div>
                                  <ngb-pagination [(page)]="currentPage" [pageSize]="pageSize" [maxSize]="10" [boundaryLinks]="true"
                                    [rotate]="true" [ellipses]="false" [collectionSize]="(control.list | appFilter: searchText).length">
                                  </ngb-pagination>
                                </div>
                              }
                            </div>
                          }
                          <!-- radio buttons -->
                          @if (control.type == 'radioButtons') {
                            <div class="col d-inline-block" style="width: 20.4rem;">
                              @if (createId(); as guidGroup) {
                                <div>
                                  @for (radioButton of control.radioButtons; track radioButton) {
                                    <div class="form-check" role="radio"
                                      [attr.tabindex]="control.selected ? 'false' : '0'" style="padding-top: .5rem;"
                                      (keydown)="index != formElements.length - 1 ? {} : selectWithEnterKey($event, control, radioButton)">
                                      @if (createId(); as guidRadio) {
                                        <div>
                                          <input class="form-check-input" type="radio" name="{{guidGroup}}" id="{{guidRadio}}"
                                            value="{{radioButton.value}}" (click)="control.selected = true; sendControlSelection(radioButton)"
                                            [disabled]="control.selected" [checked]="control.value === radioButton.value" >
                                            <label class="form-check-label" style="padding-right: 9rem;width: max-content;" for="{{guidRadio}}"   [attr.aria-label]="radioButton.label + ((control.value === radioButton.value) ? 'selected' : '  non-selected')">
                                              {{radioButton.label}}
                                            </label>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            <!-- tree control -->
                            @if (control.type == 'tree') {
                              <div class="col" style="width: 312px;">
                                <div class="tree-wrapper">
                                  <div style="display: inline;">
                                    <div class="card" style="border:none;border-radius: 0px 0px 10px 10px;">
                                      <div class="card-text cardTree scrollbarTree" id="style-2"
                                        style="padding:0px!important; overflow-y: auto; width: 100%;">
                                        <app-tree (selectedTreeItem)="control.selected = true; onSelectedtreeItemClick($event)"
                                          [isActive]="!control.selected" [treeData]="control.tree | treeFilter : treeSearchText"
                                        [searchTxt]="treeSearchText"></app-tree>
                                      </div>
                                    </div>
                                  </div>
                                  @if (index == formElements.length - 1) {
                                    <div style="display: inline;">
                                      <label class="labelTreeComponent" style="width:100%;background-color: #e9ecef;">
                                        <input type="email" class="form-control" id="search-text" aria-describedby="search-text"
                                          [(ngModel)]="treeSearchText" placeholder="Filter results"
                                          style="background-color:transparent;border:none">
                                        </label>
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                              <!-- show tiles -->
                              @if (control.type == 'tile') {
                                <div class="col" style="width: 312px;">
                                  <div class="row" style="padding-top: .5rem;">
                                    <div class="col-9">
                                      <div class="card bg-light">
                                        @if (control.title) {
                                          <div class="card-header brand-color">
                                            {{control.title}}
                                          </div>
                                        }
                                        <div class="card-body">
                                          <h6 class="card-title">{{control.subtitle}}</h6>
                                          @for (option of control.list; track option) {
                                            <div>
                                              <a href="#" class="card-link"
                                              (click)="$event.preventDefault(); sendControlSelection(option)">{{option.label}}</a>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </main>

                <footer>
                  @if (formElements.length > 1) {
                    <div class="fixed-bottom">
                      <div class="row ">
                        <div class="col-12 ">
                          <button role="button" style="float:left; height: 36px;" [ngbPopover]="attachmentsForm" [autoClose]="'outside'"
                            #p="ngbPopover" class="btn button-attach" (mouseover)="myImgSrc = '/assets/askuploadHover.svg'"
                            (mouseout)="myImgSrc = '/assets/askupload.svg'">
                            <img id="file-input-img" class="rounded" [src]="myImgSrc" alt="Esme Icon"
                              style="width:1.2rem;padding-bottom:3px" />
                              Attach Photos
                            </button>
                            <div style="float: right; margin: -3px; margin-bottom: 8px;">
                              <button id="refresh-button" role="button" class="btn button-attach" (click)="reset()"
                                style="margin-right: 6px;">
                                Refresh form
                                <div id="refresh-icon">
                                  <img style="width:19px;padding:2px;cursor:pointer;" src="assets/brand/Reset_Icon@2x.png">
                                </div>
                              </button>
                              <button role="button" [disabled]="!formElements[formElements.length - 1].showAttachments"
                                class="btn btn-primary shadow-none border-0" (click)="submitForm()"
                                (mouseover)="!!formElements[formElements.length - 1].showAttachments && paperPlaneImageSrc = 'assets/paper-plane-solid.svg'"
                                (mouseout)="paperPlaneImageSrc = 'assets/paperplane.png'">
                                Submit form
                                <img [src]="paperPlaneImageSrc" alt="Submit" style="width:1.2rem; margin-left: 5px;" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </footer>

                  <ng-template #attachmentsForm>
                    <div class="card" style="margin-top:-9px;width:550px;margin-left:-12px;margin-bottom:-9px">
                      <div class="card-header dformTextColor">
                        <p style="font-size:large;"> Attached images</p>
                        <p>
                          <small>A maximum of 5 images can be added to your request when submitted. Please avoid uploading any sensitive
                            or confidential information including photos containing other individuals or equipment without their
                          permission</small>
                        </p>
                      </div>

                      <div class="row" style="padding:1rem;margin-left:0px">
                        @for (attachment of formCreateCaseContext.attachments; track attachment) {
                          <div class="card col"
                            style="max-width: 6rem;border:none">
                            <img [src]="attachment.url" alt="{{attachment.name}}"
                              style="width: 5rem;height:5rem;background-color: #e4ecf3;">
                              <p class="text-muted" style="font-size: 11px;">
                                {{attachment.name}}
                              </p>
                            </div>
                          }

                          @if (formCreateCaseContext.attachments.length < 5) {
                            <div class="card col" tabindex="0"
                              (keydown)="attachKeyDown($event)" role="button"
                              style="max-width: 5rem;height:5rem;background-color: #E4ECF3;margin-left:12px;padding:0px">
                              <label for="file-input" class="btn btn-primary" title="Attach Photos"
                                style="cursor: pointer;width:38px;border-radius: 20px;margin-top:20px;margin-left:20px;">
                                <img style="width:1rem;cursor:pointer;padding-right: 2px; margin-top:-3px;" src="assets/brand/Add_Icon.png"
                                  title="Attach Photos">
                                </label>
                                <input type="file" id="file-input" accept="image/x-png,image/gif,image/jpeg" multiple
                                  (change)="handleFileInput($event.target.files)" style="display: none;">
                                </div>
                              }
                            </div>
                          </div>
                        </ng-template>

                        <ng-template #createCaseForm>
                          <form>
                            <div class="form-group">
                              <label for="contactName">Name</label>
                              <input type="text" class="form-control" name="formCreateCaseContextName" id="contactName"
                                aria-describedby="emailHelp" placeholder="Enter name" [(ngModel)]="formCreateCaseContext.name">
                                <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
                              </div>

                              <div class="form-group">
                                <label for="contactPhone">Phone</label>
                                <input type="text" class="form-control" name="formCreateCaseContextPhone" id="contactPhone"
                                  aria-describedby="emailHelp" placeholder="Enter phone" [(ngModel)]="formCreateCaseContext.phone">
                                </div>

                                <div class="form-group">
                                  <label for="contactEmail">Email</label>
                                  <input type="email" class="form-control" name="formCreateCaseContextEmail" id="contactEmail"
                                    aria-describedby="emailHelp" placeholder="Enter email" [(ngModel)]="formCreateCaseContext.email">
                                  </div>

                                  <div class="form-group">
                                    <label for="notes">Additional notes</label>
                                    <textarea class="form-control" id="notes" rows="3" [(ngModel)]="formCreateCaseContext.notes"></textarea>
                                  </div>

                                  <button type="submit" class="btn btn-primary" (click)="submitForm()">Submit</button>

                                </form>
                              </ng-template>

                              <ng-template #casePopContent let-modal>
                                <div class="modal-header">
                                  <h4 class="modal-title">{{modalTitle}}</h4>
                                </div>
                                <div class="modal-body">
                                  <p [innerHTML]="modalMessage"></p>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn btn-primary" (click)="reset();modal.close('Close click')">Return</button>
                                </div>
                              </ng-template>

                              <app-loading [showLoading]="requestInProgress && showLoading" [loadingMessage]="loadingMessage"></app-loading>